import { render, staticRenderFns } from "./receipt-detail.vue?vue&type=template&id=12c41b03&scoped=true&"
import script from "./receipt-detail.vue?vue&type=script&lang=js&"
export * from "./receipt-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c41b03",
  null
  
)

export default component.exports